import DailyEvents from "./dailyEvents";

export default DailyEvents;